import { render, staticRenderFns } from "./AddComplainModal.vue?vue&type=template&id=c0d8e6ba"
import script from "./AddComplainModal.vue?vue&type=script&lang=js"
export * from "./AddComplainModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports